import { Component } from "react";

interface PageSectionProps {
  children?: React.ReactNode;
  className?: string;
}

export default class PageSection extends Component<PageSectionProps> {
  public render() {
    const classes = `page-section ${this.props.className || ""}`;

    return (
      <div className={classes}>
        <div className="section-block">
          {this.props.children}
        </div>
      </div>
    );
  }
}
